<template>
  <div class="tw:flex tw:items-center tw:gap-3">
    <EdroneButtonIcon size="medium" :disabled="currentInsight <= 1" @click="handlePreviousInsight">
      <font-awesome-icon icon="fa-light fa-chevron-left" />
    </EdroneButtonIcon>

    <div>
      <span class="tw:body-1--bold tw:text-black">{{ currentInsight }}</span>
      <span class="tw:body-1 tw:text-default-600">/ {{ numberOfInsights }}</span>
    </div>

    <EdroneButtonIcon size="medium" :disabled="currentInsight >= numberOfInsights" @click="handleNextInsight">
      <font-awesome-icon icon="fa-light fa-chevron-right" />
    </EdroneButtonIcon>
  </div>
</template>

<script setup lang="ts">
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import { computed } from "vue";

interface Props {
  numberOfInsights: number;
  currentInsightIndex: number;
}

const { numberOfInsights, currentInsightIndex } = defineProps<Props>();
const currentInsight = computed(() => currentInsightIndex + 1);
const emit = defineEmits(["change-insight-index"]);

const handleNextInsight = () => {
  emit("change-insight-index", currentInsightIndex + 1);
};

const handlePreviousInsight = () => {
  emit("change-insight-index", currentInsightIndex - 1);
};
</script>
